module.exports = __webpack_public_path__ + "static/media/scenario3_preview.e7cb3f16.jpg";